
import React from "react";
import { Helmet } from "react-helmet-async";

const AdminUsers: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Manage Users - Admin Dashboard</title>
      </Helmet>
      <div className="p-6">
        <h1 className="text-3xl font-bold mb-6">Manage Users</h1>
        <p className="text-muted-foreground">User management interface.</p>
      </div>
    </>
  );
};

export default AdminUsers;
